import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AiCostsPage } from "src/components/views/ai/costs/AiCostsPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/ai/costs")({
	staticData: { title: i18n.t("ai_costs"), legacyViewKey: "aiCostsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <AiCostsPage />;
}
